import React from 'react'
import store from '../../store/Store'
import actions from '../../actions/Actions'
import settings from '../../settings/Settings'

import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import ImageIcon from '@material-ui/icons/Image'
import VideoLabelIcon from '@material-ui/icons/VideoLabel'
import TextFieldsIcon from '@material-ui/icons/TextFields'

const onClicked = (clickEvent, article, id, row, column) => {
    let selected = false

    let indexPage = id.indexOf(settings.IDENTIFICATIONS.ID_PAGE)
    let indexRow = id.indexOf(settings.IDENTIFICATIONS.ID_ROW)
    let indexColumn = id.indexOf(settings.IDENTIFICATIONS.ID_COLUMN)
    let indexText = id.indexOf(settings.IDENTIFICATIONS.ID_TEXT)
    let indexImage = id.indexOf(settings.IDENTIFICATIONS.ID_IMAGE)
    let indexVideo = id.indexOf(settings.IDENTIFICATIONS.ID_VIDEO)

    let indexMedia = 0

    // console.log('mediaActions - onClicked - indexText: ' + indexText)
    // console.log('mediaActions - onClicked - indexImage: ' + indexImage)
    // console.log('mediaActions - onClicked - indexVideo: ' + indexVideo)

    indexText >= 0 && (indexText !== undefined || indexText !== null) ? indexMedia = indexText : null
    indexImage >= 0 && (indexImage !== undefined || indexImage !== null) ? indexMedia = indexImage : null
    indexVideo >= 0 && (indexVideo !== undefined || indexVideo !== null) ? indexMedia = indexVideo : null

    // console.log(indexMedia)

	// let row = id.slice(indexRow + 1, indexColumn)
	// let column = id.slice(indexColumn + 1, indexMedia !== 0 ? indexMedia : id.length)

	row = parseInt(row)
	column = parseInt(column)

	// console.log('mediaActions - onClicked - row: ' + row)
	// console.log('mediaActions - onClicked - column: ' + column)

	article.pages.map((page, index, array) => {
		article.info.currentPage === page.index && page.selected.map((item, index, array) => {
			item.row === row && item.column === column ? selected = true : null
		})
	})

    if (indexMedia <= 0) {
    	selected 
	    ?
	      actions.articleActions.removeSelectedCell({
	      	index: article.info.currentPage,
	        row: parseInt(row),
	        column: parseInt(column)
	      })
	    :
	      actions.articleActions.addSelectedCell({
	      	index: article.info.currentPage,
	        row: parseInt(row),
	        column: parseInt(column)
	      })
    }
}

const onMouseOver = (clickEvent, article, id) => {
	// console.log('mediaActions onMouseOver')

    let row = parseInt(getRow(id))
    let column = parseInt(getColumn(id))

    actions.articleActions.addHoveredCell({
		index: article.info.currentPage,
		row: row,
		column: column
	})
}

const onMouseOut = (clickEvent, article, id) => {
	// console.log('mediaActions onMouseOut')

    let row = parseInt(getRow(id))
    let column = parseInt(getColumn(id))

    actions.articleActions.removeHoveredCell({
		index: article.info.currentPage,
		row: row,
		column: column
	})
}

const getRow = (id) => {
    return id.slice(parseInt(id.indexOf(settings.IDENTIFICATIONS.ID_ROW)) + 1, parseInt(id.indexOf(settings.IDENTIFICATIONS.ID_COLUMN)))
}

const getColumn = (id) => {
	return id.slice(parseInt(id.indexOf(settings.IDENTIFICATIONS.ID_COLUMN)) + 1, id.length)
}

const isMedia = (article, row, column): Boolean => {
	let media = false

	article.pages.map((page, index, array) => {
		article.info.currentPage === page.index && page.media.map((item, index, array) => {
			item.row === row && item.column === column ? media = true : null
		})
	})

	media === undefined || media === null ? media = false : null

	return media
}

const getMediaType = (article, row, column) => {
	let mediaType = -1

	article.pages.map((page, index, array) => {
		article.info.currentPage === page.index && page.media.map((item, index, array) => {
			item.row === row && item.column === column ? mediaType = item.type : null
		})
	})

	mediaType === undefined || mediaType === null ? mediaType = -1 : null

	return mediaType
}

const getMediaId = (article, row, column) => {
	let mediaId

	article.pages.map((page, index, array) => {
		article.info.currentPage === page.index && page.media.map((item, index, array) => {
			if (item.row === row && item.column === column) {
				switch (item.type) {
					case -1:
						mediaId = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column
						break
					case 0:
						mediaId = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_TEXT
						break
					case 1:
						mediaId = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_IMAGE
						break
					case 2:
						mediaId = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_VIDEO
						break
					default:
						mediaId = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column
						break
				}
			}
		})
	})

	mediaId === undefined || mediaId === null ? mediaId = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column : null

	return mediaId
}

const mediaElement = (article, navigation, page, row, column) => {
	let mediaElement = []

	let skip, height, width = 0
	let rowSpan, colSpan = 1

	let border, borderLeft, borderRight, borderTop, borderBottom = false
	let selected, hovered = false
	let text, image, video = false
	let checkboard = false

	let id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column

	article.pages.map((page, index, array) => {
		article.info.currentPage === page.index && page.selected && page.selected.length > 0 && page.selected.map((item, index, array) => {
			item.row === row && item.column === column ? selected = true : null
		})

		article.info.currentPage === page.index && page.hovered && page.hovered.length > 0 && page.hovered.map((item, index, array) => {
			item.row === row && item.column === column ? hovered = true : null
		})

		article.info.currentPage === page.index && page.skip && page.skip.length > 0 && page.skip.map((item, index, array) => {
			item.row === row ? skip += 1 : null
		})

		article.info.currentPage === page.index && page.border && page.border.length > 0 && page.border.map((item, index, array) => {
			item.row === row && item.column === column ? border = item.all : null
			item.row === row && item.column === column ? borderTop = item.top : null
			item.row === row && item.column === column ? borderRight = item.right : null
			item.row === row && item.column === column ? borderBottom = item.bottom : null
			item.row === row && item.column === column ? borderLeft = item.left : null
		})

		article.info.currentPage === page.index && page.width && page.width.length > 0 && page.width.map((item, index, array) => {
			item.row === row && item.column === column ? width = item.width : null
		})

		article.info.currentPage === page.index && page.height && page.height.length > 0 && page.height.map((item, index, array) => {
			item.row === row && item.column === column ? height = item.height : null
		})

		article.info.currentPage === page.index && page.media && page.media.length > 0 && page.media.map((item, index, array) => {
			item.row === row && item.column === column ? () => { switch (item.type) {
				case -1:
					id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column
					break
				case 0:
					text = true
					id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_TEXT
					break
				case 1:
					image = true
					id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_IMAGE
					break
				case 2:
					video = true
					id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_VIDEO
					break
				default:
					id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column
					break
			}} : null
		})

		article.info.currentPage === page.index && page.span && page.span.length > 0 && page.span.map((item, index, array) => {
			item.row === row && item.column === column ? colSpan = item.colSpanCount : null
			item.row === row && item.column === column ? rowSpan = item.rowSpanCount : null
		})

		row % 2 == 0 && index % 2 == 0 ? checkboard = true : row % 2 == 1 && index % 2 == 1 ? checkboard = true : null
	})

	id === undefined || id === null ? id = settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column : null
	selected === undefined || selected === null ? selected = false : null
	width === undefined || width === null ? width = 0 : null
	height === undefined || height === null ? height = 0 : null
	skip === undefined || skip === null ? skip = 0 : null
	rowSpan === undefined || rowSpan === null ? rowSpan = 1 : null  

	mediaElement.push(
	  <div
	    className="ArticleElement"
	    style={{
	      position: 'relative',
	      width: '100%',
	      height: '100%',
	      minWidth: '100%',
	      minHeight: '100%',
	      maxWidth: '100%',
	      maxHeight: '100%',
	      textAlign: 'center',
	      backgroundColor: !selected && !hovered ? 'rgba(255, 255, 255, 255)' : selected && hovered ? 'rgba(150, 150, 150, 255)' : hovered ? 'rgba(230, 230, 230, 255)' : 'rgba(120, 120, 120, 255)'
	    }}
	  >

	    {
	      selected ? (
	        <div
	          style={{
	            display: 'block',
	            position: 'absolute',
	            width: '150px',
	            height: '50px',
	            top: 'calc(50% - 25px)',
	            left: 'calc(50% - 75px)'
	          }}
	        >
	          <IconButton
	            style={{
	              display: 'inline-block'
	            }}
	            edge={ 'end' }
	            className={ 'MenuButton' }
	            color="inherit" 
	            aria-label="menu"
	            onClick={() => {
	            	actions.articleActions.addMedia({
	            		index: article.info.currentPage,
			            row,
			            column,
			            type: 0,
			            id: settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_TEXT
			          })
	            }}
	          >
	            <Icon
	              style={{
	                color: !selected && !hovered ? 'rgba(150, 150, 150, 255)' : selected && hovered ? 'rgba(255, 255, 255, 255)' : hovered ? 'rgba(120, 120, 120, 255)' : 'rgba(230, 230, 230, 255)'
	              }}
	            >
	              <TextFieldsIcon />
	            </Icon>
	          </IconButton>

	          <IconButton
	            style={{
	              display: 'inline-block'
	            }}
	            edge={ 'end' }
	            className={ 'MenuButton' }
	            color="inherit" 
	            aria-label="menu"
	            onClick={() => {
	              actions.articleActions.addMedia({
	              	index: article.info.currentPage,
		            row,
		            column,
		            type: 1,
		            id: settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_IMAGE
		          })
	            }}
	          >
	            <Icon
	              style={{
	                color: !selected && !hovered ? 'rgba(150, 150, 150, 255)' : selected && hovered ? 'rgba(255, 255, 255, 255)' : hovered ? 'rgba(120, 120, 120, 255)' : 'rgba(230, 230, 230, 255)'
	              }}
	            >
	              <ImageIcon />
	            </Icon>
	          </IconButton>

	          <IconButton
	            style={{
	              display: 'inline-block'
	            }}
	            edge={ 'end' }
	            className={ 'MenuButton' }
	            color="inherit" 
	            aria-label="menu"
	            onClick={() => {
	              actions.articleActions.addMedia({
	              	index: article.info.currentPage,
		            row,
		            column,
		            type: 2,
		            id: settings.IDENTIFICATIONS.ID_PAGE + article.info.currentPage + settings.IDENTIFICATIONS.ID_ROW + row + settings.IDENTIFICATIONS.ID_COLUMN + column + settings.IDENTIFICATIONS.ID_VIDEO
		          })
	            }}
	          >
	            <Icon
	              style={{
	                color: !selected && !hovered ? 'rgba(150, 150, 150, 255)' : selected && hovered ? 'rgba(255, 255, 255, 255)' : hovered ? 'rgba(120, 120, 120, 255)' : 'rgba(230, 230, 230, 255)'
	              }}
	            >
	              <VideoLabelIcon />
	            </Icon>
	          </IconButton>
	        </div>
	      ) : null
	    }
	    
	  </div>
	)

	return mediaElement
}

const mediaActions = {
	mediaElement,
	isMedia,
	getMediaId,
	getMediaType,
	getRow,
	getColumn,
	onClicked,
	onMouseOver,
	onMouseOut
}

export default mediaActions